import { Box, Card, CardContent, Skeleton, Typography } from "@mui/material";
import { ReactNode } from "react";
import {
  dashboardWidgetFiltersSx,
  dashboardWidgetHeaderSx,
  dashboardWidgetIconSx,
  dashboardWidgetTitleRowSx,
} from "./dashboardWidgetLayout";

interface AnalyticsHighlightCardProps {
  title: string;
  filters?: ReactNode;
  loading?: boolean;
  value?: ReactNode;
  comparison?: ReactNode;
  icon: ReactNode;
  iconBg?: string;
  iconColor?: string;
  noIcon?: boolean;
}

export default function AnalyticsHighlightCard({
  title,
  filters,
  loading = false,
  value,
  comparison,
  icon,
  iconBg = "#F4F6F8",
  iconColor = "#1F2937",
  noIcon = false,
}: AnalyticsHighlightCardProps) {
  return (
    <Card
      sx={{
        boxShadow: "0 2px 12px rgba(145, 158, 171, 0.12)",
        borderRadius: "12px",
        border: "1px solid #F0F2F5",
        overflow: "hidden",
        height: "100%",
        minHeight: { xs: 132, sm: 140 },
        "& .MuiCardContent-root": {
          padding: { xs: "10px 12px !important", sm: "12px 14px !important" },
          boxSizing: "border-box",
          height: "100%",
        },
      }}
    >
      <CardContent>
        <Box sx={{ ...dashboardWidgetHeaderSx, mb: 0.75 }}>
          <Box sx={dashboardWidgetTitleRowSx}>
            {/* {noIcon ? null : (
              <Box
                className="dashboard-widget-icon"
                sx={{
                  ...dashboardWidgetIconSx,
                  width: 26,
                  height: 26,
                  borderRadius: "7px",
                  backgroundColor: iconBg,
                  color: iconColor,
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  "& svg": { fontSize: 14 },
                }}
              >
                {icon}
              </Box>
            )} */}
            <Typography
              className="font-Saira"
              sx={{
                fontSize: { xs: 11, sm: 12, md: 13 },
                fontWeight: { xs: 500, md: 600 },
                color: "#637381",
                lineHeight: 1.2,
                textAlign: "left",
                minWidth: 0,
              }}
            >
              {title}
            </Typography>
          </Box>
          {filters ? <Box sx={dashboardWidgetFiltersSx}>{filters}</Box> : null}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            width: "100%",
          }}
        >
          <Box
            sx={{
              flex: "1 1 auto",
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              textAlign: "left",
            }}
          >
            {loading ? (
              <Skeleton
                animation="pulse"
                width={96}
                height={28}
                sx={{ borderRadius: 1, mb: 0.5 }}
              />
            ) : (
              <Box
                sx={{
                  mb: 0.25,
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  textAlign: "left",
                  "& .MuiTypography-root, & span, & p": {
                    fontSize: { xs: "18px !important", sm: undefined },
                    fontWeight: { xs: "600 !important", sm: undefined },
                  },
                }}
              >
                {value}
              </Box>
            )}
            {!loading && comparison ? (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  "& .MuiTypography-root, & span": {
                    fontSize: { xs: "11px !important", sm: undefined },
                  },
                }}
              >
                {comparison}
              </Box>
            ) : null}
          </Box>

          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              width: { xs: 48, sm: 56 },
              height: { xs: 48, sm: 56 },
              borderRadius: "50%",
              backgroundColor: iconBg,
              color: iconColor,
              alignItems: "center",
              justifyContent: "center",
              flex: { xs: "0 0 48px", sm: "0 0 56px" },
              ml: "auto",
              position: "relative",
              "&::before": {
                content: '""',
                position: "absolute",
                inset: 6,
                borderRadius: "50%",
                backgroundColor: "rgba(255,255,255,0.55)",
              },
              "& > *": {
                position: "relative",
                zIndex: 1,
                fontSize: { xs: 22, sm: 26 },
              },
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
